import { oneOfType, bool, string, func, object, node, number } from "prop-types";
import { Radio as MuiRadio, FormControlLabel } from "@material-ui/core";
import classnames from "classnames";

export const Radio = ({
  value,
  checked,
  onChange,
  name,
  error,
  style,
  label,
  labelStyle,
  labelClassName,
  className,
  colorSecondary,
  disabled = false,
  ...props
}) => {
  const checkbox = (
    <MuiRadio
      color="primary"
      checked={checked}
      value={value}
      name={name}
      className={classnames(!!error && "border-error", className)}
      onChange={onChange}
      inputProps={{ "aria-label": props["aria-label"] }}
      style={style}
      disabled={disabled}
    />
  );
  
  return label ? (
    <FormControlLabel
      control={checkbox}
      style={labelStyle}
      className={classnames("m-0", labelClassName)}
      label={
        <p
          className={classnames(
            "ml-2 text-md",
            !!error && "color-error",
            colorSecondary && "text-secondary"
          )}
        >
          {label}
        </p>
      }
    />
  ) : (
    checkbox
  );
};

Radio.propTypes = {
  value: oneOfType([number, string]).isRequired,
  name: string.isRequired,
  checked: bool,
  error: bool,
  onChange: func,
  indeterminate: bool,
  "aria-label": string,
  style: object,
  labelStyle: object,
  disabled: bool,
  colorSecondary: bool,
  className: string,
  labelClassName: string,
  label: oneOfType([string, node]),
};
